// Placeholder Swapper - Cycles through placeholder values for input fields
window.initializePlaceholderSwapper = function initializePlaceholderSwapper() {
    const inputsWithSwapPlaceholders = document.querySelectorAll('[data-swap-placeholders]');
    
    if (!inputsWithSwapPlaceholders.length) return;
    
    inputsWithSwapPlaceholders.forEach(input => {
        const placeholdersAttr = input.getAttribute('data-swap-placeholders');
        if (!placeholdersAttr) return;
        
        // Parse placeholders from comma-separated string
        const placeholders = placeholdersAttr.split(',').map(p => p.trim()).filter(p => p);
        
        if (placeholders.length === 0) return;
        
        let currentIndex = 0;
        
        // Set initial placeholder
        input.placeholder = placeholders[currentIndex];
        
        // Create interval to swap placeholders
        const intervalId = setInterval(() => {
            // Only swap if input is empty and not focused
            if (!input.value && document.activeElement !== input) {
                currentIndex = (currentIndex + 1) % placeholders.length;
                input.placeholder = placeholders[currentIndex];
            }
        }, 3000); // Change every 3 seconds
        
        // Store interval ID on element for potential cleanup
        input.setAttribute('data-swap-interval', intervalId);
        
        // Pause swapping when input is focused
        input.addEventListener('focus', function() {
            const intervalId = parseInt(this.getAttribute('data-swap-interval'));
            if (intervalId) {
                clearInterval(intervalId);
            }
        });
        
        // Resume swapping when input loses focus (if empty)
        input.addEventListener('blur', function() {
            if (!this.value) {
                const placeholdersAttr = this.getAttribute('data-swap-placeholders');
                const placeholders = placeholdersAttr.split(',').map(p => p.trim()).filter(p => p);
                
                let currentIndex = placeholders.indexOf(this.placeholder);
                if (currentIndex === -1) currentIndex = 0;
                
                const newIntervalId = setInterval(() => {
                    if (!this.value && document.activeElement !== this) {
                        currentIndex = (currentIndex + 1) % placeholders.length;
                        this.placeholder = placeholders[currentIndex];
                    }
                }, 3000);
                
                this.setAttribute('data-swap-interval', newIntervalId);
            }
        });
        
        // Stop swapping when input has value
        input.addEventListener('input', function() {
            if (this.value) {
                const intervalId = parseInt(this.getAttribute('data-swap-interval'));
                if (intervalId) {
                    clearInterval(intervalId);
                }
            }
        });
    });
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePlaceholderSwapper);
} else {
    initializePlaceholderSwapper();
}

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { initializePlaceholderSwapper };
}
